import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReportSummary, Ts1V3ManeuverBreakdownItem } from "src/app/models/models";
import { Ts1ReportPreviewContext } from "../ts1-report-preview.utils";

@Component({
	selector: "app-ts1-v4-maneuver-breakdown",
	templateUrl: "./ts1-v4-maneuver-breakdown.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1V4ManeuverBreakdownComponent {
	@Input() reportSummary?: ReportSummary;
	@Input() previewContext: Ts1ReportPreviewContext | null = null;
	@Input() maneuverBreakdownView: Ts1V3ManeuverBreakdownItem[] = [];
}
